import { GenericResponse } from "./generic-response";

export class GetRecentEmailsResponse extends GenericResponse<GetRecentEmailsResponse> {
  emails: string[] | null = null;

  constructor(init?: Partial<GetRecentEmailsResponse>) {
    super();
    Object.assign(this, init);
  }
}

export enum RecentEmailContext {
  Basket = "Basket",
  Share = "Share",
}
